module.exports = __webpack_public_path__ + "static/media/icon_phone_orange-02.dc23559f.svg";